import React from 'react'
import plural from 'smart-plurals'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'

import Link from '../Link'

const PreviewList = ({ items = [], total = 0, currentLocale, intl }) => (
  <div>
    <p className='SubHead Home__founds-caption'>
      <FormattedMessage id='preview_list.we_have' />
      {' '}190{' '}
      {plural.Plurals.getRule(currentLocale)(total,
        currentLocale === 'ru' ? [
          intl.formatMessage({id: 'common.foundation_instrumental_case'}),
          intl.formatMessage({id: 'common.foundations_instrumental_case-charity'}),
          intl.formatMessage({id: 'common.foundations_instrumental_case-charity'})
        ] : [
          intl.formatMessage({id: 'common.foundation_instrumental_case'}),
          intl.formatMessage({id: 'common.foundations_instrumental_case-charity'}),
        ]
      )}, <FormattedMessage id='preview_list.among_them' />:&nbsp;

      {items.map((fund, i) => (
        <span key={`fund-list-${fund._id}`}>
          <Link to={`/funds/${fund._id}`} className='Link'>{fund.name}</Link>
          {(i < items.length - 1) && `, `}
        </span>
      ))}
      <span> и другие</span>
    </p>

    <div style={{ textAlign: 'center' }}>
      <Link to='/funds' className='Button Button_black'>
        <FormattedMessage id='preview_list.see_all' />
      </Link>
    </div>
  </div>
)

export default injectIntl(connect(
  state => ({currentLocale: state.intl.locale})
)(PreviewList))



// WEBPACK FOOTER //
// ./src/components/Funds/PreviewList.jsx